import React from 'react';

const viPause = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path d="M0.200012 0.5C0.200012 0.223858 0.42387 0 0.700012 0H3.20001C3.47615 0 3.70001 0.223858 3.70001 0.5V11.5C3.70001 11.7761 3.47615 12 3.20001 12H0.700012C0.42387 12 0.200012 11.7761 0.200012 11.5V0.5Z" fill="currentColor" />
      {/* eslint-disable-next-line max-len */}
      <path d="M8.20001 0.5C8.20001 0.223858 8.42387 0 8.70001 0H11.2C11.4762 0 11.7 0.223858 11.7 0.5V11.5C11.7 11.7761 11.4762 12 11.2 12H8.70001C8.42387 12 8.20001 11.7761 8.20001 11.5V0.5Z" fill="currentColor" />
    </g>
  </svg>
);

export default viPause;
